// Tabs/TabPanelContent.loggers.tsx
import React from 'react';
import DynamicUploadCard from '../components/tabs/loggers_audits/DynamicUploadCard';
import UploadsCard from '../components/tabs/loggers_audits/Uploads';
import AuditTrailCard from '../components/tabs/loggers_audits/AuditTrail';
import StadisticsCard from '../components/tabs/loggers_audits/Stadistics';
import ChangeLog from '../components/tabs/loggers_audits/changeLog';

interface TabPanelContentProps {
    isReadOnly: boolean;
}

const TabPanelContentLoggers: React.FC<TabPanelContentProps> = ({ isReadOnly }) => (
    <div className="row">
        {!isReadOnly && (
            <div className="col-9 col-sm-9">
                <DynamicUploadCard header={'Upload Dynamic Collection'} eventGroupToTrigger={'loggers'} showBasket={false} storageValue={'dynamic-logger'} />
                <UploadsCard header={'Bulk Imports'} eventGroupToTrigger={'loggers'} showBasket={false} storageValue={'uploads-logger'} showContent={true} />
                <AuditTrailCard header={'Audit Trail'} eventGroupToTrigger={'loggers'} showBasket={false} storageValue={'audit-logger'} />

            </div>
        )}
        <div className="col-3 col-sm-3">
            <StadisticsCard header={'Stadistics'} eventGroupToTrigger={'loggers'} showBasket={false} storageValue={'stadistics-logger'} />
            <ChangeLog header={'Change Log'} eventGroupToTrigger={'loggers'} showBasket={false} storageValue={'change-logger'} />
        </div>
    </div>
);

export default TabPanelContentLoggers;
